import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Radio,
  notification,
  Select,
  Upload,
  message,
  Progress,
  Spin,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useSelector } from 'react-redux';
import validationRules from '../../../assets/validation/rules';
import validateForm from '../../../utils/FormValidation';
import TemplatesAPI from '../../../restAPI/TemplatesAPI';

const Context = React.createContext({
  name: "Default",
});
const { Dragger } = Upload;

const StepForm = forwardRef(({ onRefresh }, ref) => {
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const { token } = useSelector(state => state.auth);
  const [payload, setPayload] = useState({
      "_id": "",
      "file": {},
      "isFileUploaded": false,
      "name": "",
      "type": "",
      "status": 1,
      "groupId": "",
      "companyId": ""
    });
  const [errors, setErrors] = useState({});
  const [form] = Form.useForm();
  const [showUploadList, setShowUploadList] = useState(true);

  const [componentKey, setComponentKey] = useState(0); // Key for forcing re-render
  const [uploading, setUploading] = useState(false); // Track upload state
  const [progress, setProgress] = useState(0); // Track progress percentage
  const [uploadStatus, setUploadStatus] = useState(''); // Track upload status message
  //------This is for deselecting the selected file in the dragger component---------------------
  const handleUploadSuccess = () => {
    //message.success("Files uploaded successfully!");
    // Update the key to reset the Dragger component
    setComponentKey((prevKey) => prevKey + 1);
  };

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openDrawer: () => {
      setVisible(true); // Open drawer
    },
    closeDrawer: () => {
      setVisible(false); // Close drawer
      if (onRefresh) onRefresh(); // Trigger refresh on close
    },
  }));

   const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
      api[type]({
        message: message,
        description: description,
        placement
    });
    };

  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );

  const props = {
    name: "file",
    maxCount: 1,
    showUploadList: {showUploadList},
    multiple: false,
    beforeUpload: (file) => {
      setPayload({
        "_id": payload._id,
        "file": file,
        "isFileUploaded": true,
        "name": payload.name,
        "type": payload.type,
        "status": payload.status,
        "groupId": localStorage.getItem('groupId'),
        "companyId": localStorage.getItem('companyId')
      });
      setErrors({});
      const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      message.error(`${file.name} is larger than 5MB!`);
      setPayload({...payload, "isFileUploaded": false, "file": {}}); // No file selected
      handleUploadSuccess(); // deselect the selected previously selected file if exixts
      return Upload.LIST_IGNORE; // Prevent upload
    }
      return false;
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const handleChange =  (info) => {
    console.log("file changed");
    console.log(JSON.stringify(info));
    const { fileList } = info; // All selected files
    if (fileList.length > 0) {
      setPayload({...payload, "isFileUploaded": true,}); // File selected
      setProgress(0); // change back
      
    } else {
      setPayload({...payload, "isFileUploaded": false, "file": {},});; // No file selected
    }

  }

  const onTemplateTypeChange = (value) => {
    setPayload({
      "_id": payload._id,
      "file": payload.file,
      "isFileUploaded": payload.isFileUploaded,
      "name": payload.name,
      "type": value,
      "status": payload.status,
      "groupId": localStorage.getItem('groupId'),
      "companyId": localStorage.getItem('companyId')
    });
    setErrors({});
  }

  const onRadioChange = (e) => {
    setPayload({
      "_id": payload._id,
      "file": payload.file,
      "isFileUploaded": payload.isFileUploaded,
      "name": payload.name,
      "type": payload.type,
      "status": e.target.value,
      "groupId": localStorage.getItem('groupId'),
      "companyId": localStorage.getItem('companyId')
    });
  };

  function validateFormData(data) {
    const validationResult = validateForm(data, validationRules)
    if (!validationResult.isValid) {
        const err = validationResult.errors
        const newErrors = {};
        Object.keys(err).forEach((value) => {
            newErrors[value] = err[value];
        })
        setErrors(prev => ({ ...prev, ...newErrors }));
    } else {
        const keyData = Object.keys(data)[0]
        setErrors(prev => ({ ...prev, [keyData]: '' }))
    }
}

const onClose = () => {
  setVisible(false);
  if (onRefresh) onRefresh(); // Trigger refresh on drawer close
  setPayload({
    "_id": "",
      "file": {},
      "isFileUploaded": false,
      "name": "",
      "type": "",
      "status": 1,
      "groupId": localStorage.getItem('groupId'),
      "companyId": localStorage.getItem('companyId')
  });
  form.resetFields();
  setShowUploadList(false);
  setErrors({});
  setUploading(false);
  setProgress(0);
  setUploadStatus('');
  handleUploadSuccess();
} 

const onClearChange = () => {
  if (onRefresh) onRefresh(); // Trigger refresh on drawer close
  setPayload({
    "_id": "",
      "file": {},
      "isFileUploaded": false,
      "name": "",
      "type": "",
      "status": 1,
      "groupId": localStorage.getItem('groupId'),
      "companyId": localStorage.getItem('companyId')
  });
  form.resetFields();
  setShowUploadList(false);
  setUploading(false);
  setProgress(0);
  setUploadStatus('');
  handleUploadSuccess();
  setErrors({});
} 

const validateBeforeSubmit = () => {
  const validateData = {
    templateName: payload.name,
    templateType: payload.type,
    templateFile: payload.file,
  }
  console.log("Validate Result");
  console.log(validateData.templateFile);
  const validationResult = validateForm(validateData, validationRules);
  console.log(validationResult);
  if (!validationResult.isValid) {
      const validationErr = validationResult.errors;
      const newErrors = {};
      Object.keys(validationErr).forEach((value) => {
          newErrors[value] = validationErr[value];
      })
      setErrors(newErrors);
      return false;
  } else {
      return true;
  }
}
//---------------Call back function to handle progress updates (this will automatically called)---------------
const onUploadProgress = (event) => {
  const percent = Math.round((event.loaded / event.total) * 100);
  setProgress(percent); // Update progress bar
  
  // Update status message based on progress
  if (percent < 30) {
    setUploadStatus('Preparing file for upload...');
  } else if (percent < 70) {
    setUploadStatus('Uploading file to server...');
  } else if (percent < 95) {
    setUploadStatus('Encrypting and saving file...');
  } else {
    setUploadStatus('Finalizing upload...');
  }
  
  console.log("Upload progress:", percent + "%");
}
//------------------------------------------------------
const onsubmitChange = async () => {

  const validationStatus = validateBeforeSubmit();

  if(validationStatus){
  let statusValue = true;
  if(payload.status === 0){
    statusValue = false;
  }

  const formData = new FormData();
  formData.append("file", payload.file);
  formData.append("name", payload.name);
  formData.append("type", payload.type);
  formData.append("status", statusValue);
  formData.append("groupId", localStorage.getItem('groupId'));
  formData.append("companyId", localStorage.getItem('companyId'));

  //console.log(payload.file);
  //--------Code for progress bar---------------
  setUploading(true);
  setProgress(0);
  setUploadStatus('Starting upload...');
//----------------------------------------------
  await TemplatesAPI.templateUpload(token, localStorage.getItem('groupId'),  localStorage.getItem('companyId'), formData,onUploadProgress)
      .then((response) => {
        //console.log(response);
          //remove the selected files from the dragger
          handleUploadSuccess();
          setUploadStatus('Upload completed successfully!');
          openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
         // onClose();
      })
      .catch((err) => {
          setUploadStatus('Upload failed!');
          if (err.response) {
              openNotificationWithIcon('error', 'Template upload failed', `${err.response.data.message}`, 'bottomLeft');
          } else {
              openNotificationWithIcon('error', 'Template upload failed', `${err.message}`, 'bottomLeft');
          }
      }).finally(()=>{
        //setUploading(false);
        setTimeout(() => {
          setUploading(false);
          setProgress(0);
          setUploadStatus('');
          onClose();
      }, 1500);
      });
    }
    else{
      console.log("No Upload incomplete data");
    }
}

const onFinish = (values) => {
  form.resetFields();
};

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        title="Upload Template"
        width={700}
        visible={visible}
        onClose={() => onClose()}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button 
              onClick={onClearChange} 
              style={{ marginRight: 8 }} 
              size="large"
              disabled={uploading}
            >
              Reset
            </Button>

            <Button
              type="primary"
              size="large"
              onClick={onsubmitChange}
              loading={uploading}
              disabled={uploading}
            >
              {uploading ? 'Uploading...' : 'Submit'}
            </Button>
          </div>
        }
      >
        <div style={{ marginTop: 24 }}>
          <Form layout="vertical" onFinish={onFinish}>
            {/* <Alert message="* Fields are required" type="warning" /> */}

            <Form.Item label="Template Name" validateStatus={errors.templateName ? 'error' : ''} help={errors.templateName || ''} required>
              <Input size="large" name="templateName" value={payload["name"]} onChange={(e) => { setPayload(prev => ({...prev, name: e.target.value})); const validateData = {templateName: e.target.value}; validateFormData(validateData); }} placeholder="Template Name" />
            </Form.Item>

            <Form.Item label="Template Type" validateStatus={errors.templateType ? 'error' : ''} help={errors.templateType || ''} required>
              <Select
                showSearch
                name="templateType"
                placeholder="Select Template Type"
                optionFilterProp="label"
                onChange={onTemplateTypeChange}
                size="large"
                value={payload["type"] || "Select a Template Type"}
                options={[
                  {
                    value: "Accounts receivable",
                    label: "Accounts Receivable",
                  },
                  {
                    value: "Accounts payable",
                    label: "Accounts Payable",
                  },
                ]}
              />
            </Form.Item>

            <Form.Item name="file" label="File" validateStatus={errors.templateFile ? 'error' : ''} help={errors.templateFile || ''} 
            rules={[{ required:true,message:"Please Select a File"},]}>
              <Dragger {...props} 
              onChange={handleChange} key={componentKey}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag Excel file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a Single Excel file (.xlsx) upload.
                </p>
              </Dragger>
            </Form.Item>
             {/* Display Progress Bars */}
            <div style={{ marginTop: 10 }}>
            {uploading && (
              <div>
                <Progress 
                  percent={progress} 
                  style={{ marginTop: 10 }} 
                  status={progress === 100 ? 'success' : 'active'}
                />
                {uploadStatus && (
                  <div style={{ 
                    textAlign: 'center', 
                    marginTop: 8, 
                    color: progress === 100 ? '#52c41a' : '#1890ff',
                    fontWeight: 500
                  }}>
                    <Spin size="small" style={{ marginRight: 8 }} />
                    {uploadStatus}
                  </div>
                )}
              </div>
            )}
            </div>
              {/* Diplay File is selected */}
            <div style={{ marginTop: 20 }}>
                {payload?.isFileUploaded ? (<p style={{ color: "green" }}>File(s) selected!</p>) : (
                <p style={{ color: "red" }}></p>
                   )}
            </div>
            
            <Form.Item label="Status" required>
                <Radio.Group name="status" value={payload["status"]} onChange={onRadioChange}>
                  <Radio value={1}>Active</Radio>
                  <Radio value={0}>Inactive</Radio>
                </Radio.Group>
              </Form.Item>

          </Form>
        </div>
      </Drawer>
    </Context.Provider>
  );
});

export default StepForm;
